var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":"是否必填"}},[_c('el-switch',{model:{value:(_vm.data.required),callback:function ($$v) {_vm.$set(_vm.data, "required", $$v)},expression:"data.required"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77634ce6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/avue/small-component/textarea.vue
// module id = null
// module chunks = 